import { generator } from '../event-listener.js';
export const OnOpen = generator('onOpen');
//# sourceMappingURL=openable.js.map